<div style="padding: 0;border: rgb(194, 194, 194) SOLID 2px; overflow: auto" [style.height]='height'>
  <ngx-monaco-editor style="height: 100%; min-height: 30px; min-width: 200px; font-size: xx-small;" [options]="editorOptions" [(ngModel)]="data"  (onInit)="onInit($event)"></ngx-monaco-editor>
</div>
